import React, { useRef } from 'react'
import { AppCardTitle, AppCrudTable, AppResultsSkeleton, AppStartHint } from '@components'
import { sitesColumn, numSearchesColumn, frequencyColumn, frequencyHoursColumn, nameColumn, officesColumn } from './@columns'
import { reportsHandlerTableData, isReportsHandlerLoading } from 'Pages/Admin/ReportsHandler/@signals'
import ReportsHandlerSelectToolbar from 'Pages/Admin/ReportsHandler/Table/SelectToolbar'


export default function ReportsHandleTable() {
	// The hint is for a page where no user origin was picked yet; after that an empty list shows nothing, as before
	const hasLoaded = useRef(false)
	if (isReportsHandlerLoading.value) hasLoaded.current = true

	if (isReportsHandlerLoading.value) {
		return <AppResultsSkeleton/>
	} else if (!reportsHandlerTableData.value.length) {
		return hasLoaded.current ? null : <AppStartHint
			icon="user"
			title="Select a user origin to start"
			description="Pick a user above to see their reports"
		/>
	}

	return <AppCrudTable
		data={reportsHandlerTableData.value}
		title={<AppCardTitle icon="file-lines" title="Users & Reports List"/>}
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <ReportsHandlerSelectToolbar
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>
		}}
		columns={[nameColumn(), ...sitesColumn(), numSearchesColumn(), frequencyColumn(), frequencyHoursColumn(), ...officesColumn()  ]}
	/>
}